import { useId } from 'react';
import Overlay from './Overlay';
import Selector from './Selector';
import Button from './Button';
import ProductCounter from './subscription/ProductCounter';
import styles from './OrderForm.module.css';

export default function OrderForm({
  formData, onChange, products, deliveries, assignedDeliveryId, onDeliveryChange,
  sites, originSiteId, onOriginChange, sitesLoading, sitesError,
  deliverToSite, canDeliverToSite, onDestinationChange, onConfirm, onCancel,
  maxWidth = '68rem',
}) {
  const id = useId();

  return (
    <Overlay portal className={styles.modal} backdropClassName={styles.backdrop}>
      <div className={styles.form} style={{ '--order-form-width': maxWidth }}>
        <header className={styles.header}>
          <h2>New Order</h2>
          <p>Choose your products and delivery details.</p>
        </header>
        <div className={styles.body}>
          <div className={styles.products}>
            {products.map(product => (
              <section className={styles.product} key={product.fieldName} aria-label={product.name}>
                <ProductCounter
                  className={styles.counter}
                  showSelection={false}
                  name={product.name}
                  value={formData[product.fieldName]}
                  fieldName={product.fieldName}
                  handleChange={onChange}
                />
                <label className={styles.checkbox}>
                  <input type="checkbox" checked={product.ebcRequired} onChange={product.onEbcChange} />
                  <span>{product.name} requires EBC certification</span>
                </label>
              </section>
            ))}
          </div>
          <section className={styles.delivery} aria-labelledby={`${id}-delivery`}>
            <h3 id={`${id}-delivery`}>Delivery details</h3>
            <label className={styles.dateLabel} htmlFor={`${id}-date`}>Delivery date</label>
            <input id={`${id}-date`} className={styles.date} type="date" value={formData.date}
              onChange={event => onChange('date', event.target.value)} />
            <div className={styles.field}>
              <Selector native name="Assigned Delivery" value={assignedDeliveryId} data={deliveries}
                onChange={onDeliveryChange} labelStyle="top" placeholder="Select delivery" color="white" />
            </div>
            <div className={styles.field}>
              <Selector native name="Origin / Pickup Site" value={originSiteId}
                data={sites.map(site => ({ name: site.name, value: site._id }))}
                onChange={onOriginChange} labelStyle="top" color="white"
                placeholder={sitesLoading ? 'Loading pickup sites…' : 'Select pickup site'} />
            </div>
            {sitesError && <p className={styles.error} role="alert">{sitesError}</p>}
            <label className={styles.checkbox}>
              <input type="checkbox" checked={deliverToSite} disabled={!canDeliverToSite}
                onChange={onDestinationChange} aria-describedby={!canDeliverToSite ? `${id}-storage` : undefined} />
              <span>Assign delivery to storage</span>
            </label>
            {!canDeliverToSite && <p id={`${id}-storage`} className={styles.hint}>No storage site is linked to this farmer.</p>}
          </section>
        </div>
        <footer className={styles.actions}>
          <Button name="Cancel" color="Coal" onPress={onCancel} customStyle={{ margin: 0 }} />
          <Button name="Confirm Order" onPress={onConfirm} customStyle={{ margin: 0 }} />
        </footer>
      </div>
    </Overlay>
  );
}
